module.exports = __webpack_public_path__ + "static/media/logo116.6b4a4b2f.png";